module.exports = __webpack_public_path__ + "img/us-flag.d9cc90c9.png";